/// <reference path="../_all.ts" />

declare var pglob : IPhotometerGlobalVar;

module library {
  'use strict';
  
  export class Toolbox2Ctrl {

    public static $inject = [
      '$scope',
      '$location',
      '$timeout',
      'toolboxService',
      'searchService',
      'libraryService',
      'pageMetaService',
      '$mdPanel',
    ];

    constructor(
      private $scope: IToolbox2CtrlScope,
      private $location: ng.ILocationService,
      private $timeout: ng.ITimeoutService,
      private toolboxService : IToolboxService,
      private searchService: search.ISearchService,
      private libraryService : ILibraryService,
      private pageMetaService : navigation.IPageMetaService,
      private $mdPanel : ng.material.IPanelService
      ) {

      $scope.vm = this;      
      $scope.meta = pageMetaService.getPageMeta;
      $scope.products = []; 
      //$scope.categoryFilter = $scope.categoryFilter || 5;
      //$scope.contentFilter = $scope.contentFilter || 5;

      $scope.queryString = $location.search().q;
      $scope.$watch('queryString', (newVal: string, oldVal: string) => {
        if (newVal != oldVal) {
          //$location.search({ q: newVal });
          this.callSearchFunction(); 
        }
      });

      var productZeroName = $scope.meta(navigation.HL) == "D" ? "Allgemeine Dokumente" : "General documents"

      toolboxService.getProducts().then((response) => {
        $scope.products = response.data;
        $scope.products.unshift(<any>{  "Id" : 0, "Name" : productZeroName});
      });
      
    }

    
    hideTypes : number[] = [ 15, 38, 26 ];
    selectedProductIds : number[] = [  ];
    oldCatId : number = null;
    oldTypeId : number = null;

    setProduct(p: search.Product) { 
      this.$scope.selectedProduct = p;
      var re : IRouteEntry =  <any> { RouteParameterStack : [ { "Id" : p.Id, "Placeholder" : "ProductName" } ] };

      if (this.$scope.selectedCategory) {
        this.oldCatId = this.$scope.selectedCategory.DocumentCategoryID;
      } 
      if (this.$scope.selectedType) {
        this.oldTypeId = this.$scope.selectedType.DocumentTypeID;
      } 

      this.libraryService.loadDocumentsByProduct(re, this.$scope.contentFilter, this.$scope.categoryFilter).then((response) => {
        
        this.$scope.documents = response.data.Documents;
        this.$scope.languages = response.data.Languages;

        var oldCat = this.$scope.documents.filter((c)=>{ return c.DocumentCategoryID == this.oldCatId });

        if (oldCat.length > 0) {
          this.setSelectedCategory(oldCat[0]);
          
          var oldType = oldCat[0].Types.filter((t)=>{ return t.DocumentTypeID== this.oldTypeId });
          if (oldType.length > 0) {
            this.setSelectedType(oldType[0]);
          } 

        } else if (this.$scope.documents.length > 0) {
          this.setSelectedCategory(this.$scope.documents[0])
        }

      });
    }

    setSelectedCategory(dc : DocumentCategory) {
      this.$scope.selectedCategory  = dc;
      if (dc.Types.length > 0) {
        this.$scope.selectedType = dc.Types[0];
      }
    }

    setSelectedType(t : DocumentType) {
      this.$scope.selectedType  = t;
    }
    
    setSelectedDocument(d : Document, isFullTextHit : boolean) {
      if (!isFullTextHit) {
        this.$scope.selectedDocument = d;
        this.$scope.selectedRevision  = this.getDefaultRevision(d);
      } else {
        this.libraryService.loadDocumentDetails(null, (<any>d).DocumentFileSrcRevId).then((data) =>  {
          this.$scope.error = null;
          this.$scope.languages = data.Languages;
          this.$scope.selectedDocument = data.Document;            
          var rev = data.Document.Revisions.filter((v, i, arr) => { return v.DocumentFileSrcRevID == (<any>d).DocumentFileSrcRevId});

          if (rev.length > 0) {
            this.$scope.selectedRevision = rev[0]; 
          } else {
            this.$scope.selectedRevision  = this.getDefaultRevision(data.Document);
          }
        }).catch((err) => {
          this.$scope.selectedDocument = null;
          this.$scope.selectedRevision  = null;
          this.$scope.error = err.status + ': ' + err.statusText;
        }).finally(() => {
        }); 
      }

    }
   
    
    getDefaultRevision(doc :  Document, hl? : string, fileType? : String) {
      return this.libraryService.getDefaultRevision(doc, hl, fileType);
    }

    
    openDetailModal(ev: MouseEvent, d : Document,  rev : DocumentRev)  {      
      this.openDetailModalByRevId(ev, rev.DocumentFileSrcRevID, d, rev);
    }
    
    openDetailModalByRevId(ev: MouseEvent, revid : number, d? : Document,  rev? : DocumentRev)  {      
      this.libraryService.openDialog(revid, this.$scope, ev);
    }

    getLanguageDescription(code: string) {
      if (!this.$scope.languages) return code;
      var lngs = this.$scope.languages.filter((v, i, arr) => {
        return code === v.LanguageCode;
      });

      if (lngs) return lngs[0].LanguageName;
    }
      

    callSearchFunction() {
      this.$scope.selectedDocument = null;
      if (this.$scope.queryString) {
        this.searchService.searchLibrary(this.$scope.queryString, 0, 100, false).then((response: { data: any }) => {
          this.$scope.searchResults = { Hits: response.data.Hits, Count: response.data.Count };
        })
      }
    }

    showProductFilter(ev :  ng.IAngularEvent) {
      var position = this.$mdPanel.newPanelPosition()
        .relativeTo('.produkt-filter-open-button')
        .addPanelPosition(this.$mdPanel.xPosition.ALIGN_START, this.$mdPanel.yPosition.BELOW);

      
      var config = {
        attachTo: angular.element(document.body),
        controller: ProductFilterCtrl,
        controllerAs: 'ctrl',
        templateUrl: 'library/ProductFilterPanel',            
        panelClass: 'product-filter-pnl',
        position: position,
        locals: {
          'products': this.$scope.products,
          'selected' : this.selectedProductIds,
        },
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
        disableParentScroll: false,
        zIndex: 1000 /* $z-index-material-base */
      };

      this.$mdPanel.open(config);
    }

    filterSelectedProducts() {
      var self = this;
      return function(item){
        if (!self || !self.selectedProductIds) return true;
        if (self.selectedProductIds.length === 0) return true;
        return self.selectedProductIds.filter(k=> item.Id == k).length;
      }
    }



    
    
    
    
  }
}